<template>
    <div>
        <i>
            The driver does not have any specific settings.
        </i>
    </div>
</template>

<script>
export default {}
</script>
